import Link from 'next/link'
import {memo} from 'react'

import {IconMediaPlay} from '@defign/asset'
import classNames from 'classnames/bind'

import Styles from '$components/insurance/contents/InsuranceTipList.module.scss'
import {INTERNAL_ROUTES} from '$constants/internal-routes'
import {ContentResponse} from '$share/types/insurance/contents'
import {sendClickNlog} from '$utils/nlog'

import HighlightedText from './HighlightedText'

const cx = classNames.bind(Styles)

interface InsuranceTipListItemProps {
    id: number
    title: string
    hashTag: string[]
    imageUrl?: string
    hasVideo?: boolean
    searchKeyword?: string
    searchType?: boolean
}
const InsuranceTipListItem = memo(function InsuranceTipListItem({
    id,
    title,
    hashTag,
    imageUrl,
    hasVideo = false,
    searchKeyword,
    searchType,
}: InsuranceTipListItemProps) {
    const handleClick = () => {
        sendClickNlog(searchType ? 'insutipsrch.contents' : 'insutipcat.contents')
    }
    return (
        <li className={cx('item')}>
            <Link
                href={{pathname: INTERNAL_ROUTES['INSURANCE_CONTENTS_[ID]'], query: {id}}}
                className={cx('link')}
                onClick={handleClick}
            >
                {imageUrl && (
                    <div className={cx('image-area')}>
                        <img src={imageUrl} style={{display: 'block', width: 70, height: 70}} alt={title} />

                        {hasVideo && (
                            <span className={cx('icon-play')}>
                                <IconMediaPlay width={12} height={12} />
                                <span className="blind">{title + ' 썸네일'}</span>
                            </span>
                        )}
                    </div>
                )}
                <div className={cx('text-area')}>
                    {/* [D] 검색 결과에서 노출시 검색어와 동일한 문자는 em태그로 감싸주세요. ex) <em>보험</em> */}
                    <strong className={cx('title')}>
                        <HighlightedText text={title} searchText={searchKeyword} highlightElement="em" />
                    </strong>
                    <div className={cx('keyword')}>
                        <strong className={cx('blind')}>키워드</strong>
                        <ul>
                            {hashTag.map((item, key) => {
                                return (
                                    <li key={key} className={cx('tag')}>
                                        #
                                        <HighlightedText text={item} searchText={searchKeyword} highlightElement="em" />
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </Link>
        </li>
    )
})

interface InsuranceTipListProps {
    searchType?: boolean
    searchKeyword?: string
    shouldShowTipList?: boolean
    contents: ContentResponse[]
}

const InsuranceTipList = ({
    searchType = false,
    shouldShowTipList = true,
    searchKeyword,
    contents,
}: InsuranceTipListProps) => {
    return (
        <ul className={cx('article', {'search-result': searchType})}>
            {shouldShowTipList &&
                contents.map(({contentsSeqno, title, keyword, videosYn, imageUrlSquare}) => (
                    <InsuranceTipListItem
                        key={contentsSeqno}
                        id={contentsSeqno}
                        title={title}
                        hashTag={keyword}
                        imageUrl={imageUrlSquare}
                        hasVideo={videosYn}
                        searchKeyword={searchKeyword}
                        searchType={searchType}
                    />
                ))}
        </ul>
    )
}

export default memo(InsuranceTipList)
